<div class="card">

    <div class="contenedor-boton">
      <button 
        pButton 
        type="button" 
        icon="pi pi-download" 
        class="p-button-rounded boton-rosado" 
        pTooltip="Descargar Plantilla"
        tooltipPosition="top"
        (click)="descargarPlantilla()">
      </button>
    </div>

    <p-fileUpload 
    name="demo[]" 
    url="http://localhost:3000/upload" 
    (uploadHandler)="uploadFiles($event)" 
    chooseLabel="Seleccionar Archivo" 
    uploadLabel="Subir"
    cancelLabel="Cancelar"
    [multiple]="false" 
    accept=".xlsx, .xls" 
    maxFileSize="5000000"
    [showUploadButton]="true"
    [showCancelButton]="true"
    [customUpload]="true"
    >
  <!-- Personalizar el área de arrastre -->
  <ng-template pTemplate="empty">
    <div class="drop-zone">
      <i class="pi pi-cloud-upload"></i>
      <p>Arrastra y suelta tus archivos aquí</p>
      <small>O haz clic en "Seleccionar Archivo"</small>
    </div>
  </ng-template>
    </p-fileUpload>
  </div>
